"use client";
import { useState } from 'react'
import { ProductGallery } from './ProductGallery'
import { ProductInfo } from './ProductInfo'
import type { Product, ProductVariant, ProductImage } from '@/types'

interface Props {
  product: Product
  activeVariant: ProductVariant | null
  sizeVariants: ProductVariant[]
  colorVariants: ProductVariant[]
  previewImages: ProductImage[]
  categoryName: string
  specsSection?: React.ReactNode
}

export function ProductDetailsContainer({
  product,
  activeVariant,
  sizeVariants,
  colorVariants,
  previewImages,
  categoryName,
  specsSection,
}: Props) {
  const [hoveredImage, setHoveredImage] = useState<string | null>(null)

  const galleryImages = [
    ...previewImages.map((img) => ({ id: img.id, image_url: img.image_url, label: 'Preview' })),
    ...(activeVariant?.image_url
      ? [{ id: `v-main-${activeVariant.id}`, image_url: activeVariant.image_url, label: 'Primary' }]
      : []),
    ...(product.image_url && product.image_url !== activeVariant?.image_url
      ? [{ id: 'product-main', image_url: product.image_url, label: 'Main' }]
      : [])
  ]

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
      {/* Left: Sticky image gallery */}
      <div className="lg:sticky lg:top-28">
        <ProductGallery
          productName={product.name}
          galleryImages={galleryImages}
          hoveredImage={hoveredImage}
        />
      </div>

      {/* Right: Product info + Specs stacked — scrolls freely */}
      <div className="flex flex-col gap-10">
        <ProductInfo
          product={product}
          activeVariant={activeVariant}
          sizeVariants={sizeVariants}
          colorVariants={colorVariants}
          categoryName={categoryName}
          onHoverImage={setHoveredImage}
        />
        {specsSection}
      </div>
    </div>
  )
}
